import { DeliveryFeeSettings } from "../../../../models/DeliveryFeeSettings"
import { calculateDeliveryFee } from "../../../../lib/deliveryFee"

export type DeliveryFeePreviewProps = {
  deliveryFeeSettings: DeliveryFeeSettings
  hasUnsavedChanges: boolean
}

export const DeliveryFeePreview: React.FC<DeliveryFeePreviewProps> = ({ deliveryFeeSettings, hasUnsavedChanges }) => {
  const distances = getDistancesUpTo(deliveryFeeSettings.maxMiles)

  return (
    <div className="mt-8 border rounded-md">
      <div className="flex items-center justify-between px-4 py-2 border-b">
        <div className="text-sm font-medium text-gray-700">Delivery fee by distance</div>

        {hasUnsavedChanges ? (
          <span className="text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full px-2 py-0.5">
            Previewing unsaved changes
          </span>
        ) : null}
      </div>

      {distances.length === 0 ? (
        <div className="px-4 py-2 text-sm text-gray-500">Enter a valid max distance to see the delivery fees.</div>
      ) : (
        distances.map((distance, index) => {
          const fee = calculateDeliveryFee(distance, deliveryFeeSettings)

          return (
            <div
              key={distance}
              className={`flex items-center justify-between px-4 py-2 text-sm ${index > 0 ? "border-t border-gray-200" : ""}`}
            >
              <span>{distance.toFixed(1)} miles</span>
              <span className="font-medium">{Number.isFinite(fee) ? `£${(fee / 100).toFixed(2)}` : "—"}</span>
            </div>
          )
        })
      )}
    </div>
  )
}

function getDistancesUpTo(maxMiles: number): number[] {
  if (!Number.isFinite(maxMiles) || maxMiles <= 0) {
    return []
  }

  const distances: number[] = []

  for (let distance = 0; distance <= maxMiles + 1e-9; distance += 0.5) {
    distances.push(distance)
  }

  return distances
}
